import React from 'react'
import './Section3.css';
import Bubble from './Bubble';
function Section3() {
  return (
    <div className='section3' id='section_skills'>
        <div className='section3__left'>
            <div className='section3__left__1'>
                <p>My skills</p>
            </div>
            <div className='section3__left__2'>
                <p>
    I possess comprehensive backend expertise in Spring Boot, including implementing RESTful APIs and integrating JWT for stateless authentication. My database knowledge covers both relational and NoSQL, with practical experience in database creation, migration, and performance tuning.
</p>
            </div>
            <div className='section3__left__3'>
                <a href="https://drive.google.com/file/d/1cZUFCZXMEwn7zMoW8bVWKUpyaxYeDx0D/view?usp=drive_link" className='btn'>My CV</a>
            </div>
        </div>
        <div className='section3__right'>
            <div className='section3__right__1'>
                <Bubble bgColor="linear-gradient(180deg, rgba(243, 72, 72, 0.81) 0%, rgba(230, 155, 242, 0.81) 100%)" 
                text="Node js" />
            </div>
            <div className='section3__right__2'>
                <Bubble bgColor="linear-gradient(180deg, rgba(72, 202, 243, 0.81) 0%, rgba(230, 155, 242, 0.81) 100%)" 
                text="Spring Boot" />
                <Bubble bgColor="linear-gradient(180deg, rgba(99, 54, 226, 0.81) 0%, rgba(223, 109, 238, 0.81) 99.99%, rgba(216, 22, 22, 0.81) 100%)"  
                text="DSA" />
            </div>
            <div className='section3__right__3'>
                <Bubble bgColor="linear-gradient(180deg, rgba(77, 254, 95, 0.81) 0%, rgba(202, 217, 28, 0.81) 100%)" 
                text="React js" />
            </div>
            <div className='section3__right__4'>
                <Bubble bgColor="linear-gradient(180deg, rgba(255, 126, 6, 0.81) 0%, rgba(211, 75, 75, 0.81) 100%)" 
                text="JAVA" />
                <Bubble bgColor="linear-gradient(180deg, rgba(243, 72, 72, 0.81) 0%, rgba(242, 197, 155, 0.81) 100%)" 
                text="SQL" />
            </div>
            <div className='section3__right__5'>
                <Bubble bgColor="linear-gradient(180deg, rgba(75, 243, 72, 0.81) 0%, rgba(230, 155, 242, 0.81) 100%)" 
                text="MongoDB" />
            </div>
            
        </div>
    </div>
  )
}

export default Section3